import classnames from 'classnames';

import { Button, Popup } from 'components/assessment';
import { useAssessmentStateActions } from 'AppFlow/Summary/Assessment/state';

import s from './SkillStrengthCard.module.scss';
import useSkillStrengthCardState from './state/useStrengthCardState';
import { useSkillStrengthCardStateActions } from './state/selectors';
import { useLanguageDirection, useTranslation } from 'appState';

type Props = {
  id: string;
  title: string;
  subtitle?: string;
  description: string;
  type: 'emotionalIntelligence'
  | 'cognitive'
  | 'personality'
  | 'behavior';
  popupContent?: React.ReactElement[] | React.ReactElement | undefined;
  interactionType: 'mainFeedbackInteractions' | 'entrepreneurshipInteractions';
};

const SkillStrengthCard: React.FC<Props> = ({
  id,
  title,
  subtitle,
  description,
  type,
  popupContent,
  interactionType,
}) => {
  const dir = useLanguageDirection();

  const { isSkillsStrengthCardOpen, skillsStrengthCardOpenName } = useSkillStrengthCardState();
  const { toggleSkillStrengthCard } = useSkillStrengthCardStateActions();
  const { incrementInteraction } = useAssessmentStateActions();
  const lang = useTranslation('SkillStrengthCard');
  const onLearnMoreClick = () => {
    if (subtitle) {
      incrementInteraction(interactionType, subtitle);
    }
    toggleSkillStrengthCard(true, id);
  };

  return (
    <div
      className={classnames(s.card, {
        [s.emotionalIntelligence]: type === 'emotionalIntelligence',
        [s.cognitive]: type === 'cognitive',
        [s.personality]: type === 'personality',
        [s.behavior]: type === 'behavior',
      })}
    >
      <span className={s.icon} />
      <h4 className={s.title}>{title}</h4>
      { subtitle && type !== 'personality' && <span className={s.subtitle}>{subtitle}</span>}
      { description && <p className={s.description} dir={dir}>{description}</p>}

      {
        popupContent && (
          <>
            <Button onClick={onLearnMoreClick}>{lang.learnMore}</Button>
            <Popup
              isOpen={isSkillsStrengthCardOpen && skillsStrengthCardOpenName === id}
              onClose={() => toggleSkillStrengthCard(false)}
            >
              {popupContent}
            </Popup>
          </>
        )
      }
    </div>
  );
};

export default SkillStrengthCard;
